import { Reducer } from 'redux';
import { WelcomeActionTypes, WelcomeState } from './types';

export const initialState: WelcomeState = {
  verification: 'initial'
};

const reducer: Reducer<WelcomeState> = (state = initialState, action: any) => {
  switch (action.type) {
    case WelcomeActionTypes.VERIFY_INVITE_TOKEN_START: {
      return {
        ...state,
        verification: 'verifying'
      };
    }
    case WelcomeActionTypes.VERIFY_INVITE_TOKEN_SUCCESS: {
      return {
        ...state,
        verification: 'success'
      };
    }
    case WelcomeActionTypes.VERIFY_INVITE_TOKEN_FAILURE: {
      return {
        ...state,
        verification: 'fail',
        error: action.payload
      };
    }
    default:
      return state;
  }
};

export default reducer;
